export default {
    isAppLoading: (state) => {
        return state.isAppLoading;
    },

    isAppInitialized: (state) => {
        return state.isAppInitialized;
    },

    isAppInitializing: (state) => {
        return state.isAppInitializing;
    },

    getAuthUserAppResource: (state) => {
        return state.authUserAppResource;
    },
};
